<template>
  <div>
    <div class="font-weight-bold mb-3">Reseller Details</div>
    <b-list-group
      v-if="selectedResellerId !== null"
      :flush="flush"
      class="mb-1">
      <b-list-group-item
        class="d-flex align-items-center"
        :class="{ 'px-0' : flush }">
        ID
        <span class="ml-auto">#{{ selectedReseller.id }}</span>
      </b-list-group-item>
      <b-list-group-item
        class="d-flex align-items-center"
        :class="{ 'px-0' : flush }">
        Created
        <span class="ml-auto">{{ selectedReseller.created | moment("DD.MM.YYYY, HH:mm") }}</span>
      </b-list-group-item>
      <b-list-group-item
        class="d-flex align-items-center"
        :class="{ 'px-0' : flush }">
        Tariff
        <span class="ml-auto">{{ selectedReseller.tariff.name }}</span>
      </b-list-group-item>
      <b-list-group-item
        class="d-flex align-items-center"
        :class="{ 'px-0' : flush }">
        Devices
        <reseller-capacity
          :item="selectedReseller"
          :param="'devices'"
          :isLoading="resellersResponses('getReseller')"
          class="ml-auto" />
      </b-list-group-item>
      <b-list-group-item
        class="d-flex align-items-center"
        :class="{ 'px-0' : flush }">
        Users
        <reseller-capacity
          :item="selectedReseller"
          :param="'users'"
          :isLoading="resellersResponses('getReseller')"
          class="ml-auto" />
      </b-list-group-item>
      <b-list-group-item
        class="d-flex align-items-center"
        :class="{ 'px-0' : flush }">
        Status
        <span class="ml-auto font-size-xs">
          <b-badge :variant="resellerStatusBadge(selectedReseller).variant">
            <i :class="`fa fa-sm fa-${resellerStatusBadge(selectedReseller).icon} text-white`"></i>
            {{ resellerStatusBadge(selectedReseller).text }}
          </b-badge>
        </span>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ResellerCapacity from './ResellerCapacity.vue'

export default {
  name: 'ResellerDetailsPlate',
  components: {
    ResellerCapacity
  },
  props: {
    flush: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  computed: {
    ...mapGetters([
      'selectedReseller',
      'selectedResellerId',
      'resellerStatusBadge',
      'resellersResponses',
    ]),
  }
}
</script>
